import { render } from "./ExpensesPage.vue?vue&type=template&id=28172b41&scoped=true"
import script from "./ExpensesPage.vue?vue&type=script&lang=js"
export * from "./ExpensesPage.vue?vue&type=script&lang=js"

import "./ExpensesPage.vue?vue&type=style&index=0&id=28172b41&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28172b41"]])

export default __exports__